import type { LucideIcon } from "lucide-preact";
import type { ComponentChildren } from "preact";

export const CARD = "bg-white dark:bg-neutral-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700";

export type SettingsCardProps = {
  icon: LucideIcon;
  title: string;
  children: ComponentChildren;
};

/** The white card of a settings panel, with its icon and title. */
export const SettingsCard = ({ icon: Icon, title, children }: SettingsCardProps) => (
  <div class={`${CARD} p-6`}>
    <div class="flex items-center gap-2 mb-4">
      <Icon class="text-gray-700 dark:text-gray-300" size={20} />
      <h2 class="text-lg font-semibold text-gray-900 dark:text-white">{title}</h2>
    </div>
    {children}
  </div>
);

/** The round radio mark of a selected option. */
export const SelectedMark = () => (
  <div class="w-5 h-5 rounded-full bg-blue-600 flex items-center justify-center flex-shrink-0">
    <div class="w-2 h-2 bg-white rounded-full" />
  </div>
);
